// extracted by mini-css-extract-plugin
module.exports = {"posts":"style_posts__ISxBE","article":"style_article__MQ89F","more":"style_more__tSGA3"};